import script from "./Quiz.vue?vue&type=script&setup=true&lang=js"
export * from "./Quiz.vue?vue&type=script&setup=true&lang=js"

import "./Quiz.vue?vue&type=style&index=0&id=7b3c4597&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b3c4597"]])

export default __exports__